import React, { Component } from "react";
import LinkOffRoundedIcon from '@material-ui/icons/LinkOffRounded';

/**
 * @param {{
 *  message: string;
 * }} params 
 * @returns {React.JSX.Element}
 */
export function BrokenComponent({
  message,
}) {
  return (
    <div className='flex flex-column flex-fill align-items-center justify-content-center gap-16'>
      <LinkOffRoundedIcon fontSize='medium' />
      <p className='m-0 p-0 align-center font-roboto font-14'>{message}</p>
    </div>
  );
}

class ErrorHandler extends Component {
  /**
   * 
   * @param {{
   *  children: React.JSX.Element | undefined;
   *  fallback: React.JSX.Element | undefined;
   * }} props 
   */
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log(`@logger: caught error in lifecycle`, error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <BrokenComponent
          message={this.props.message}
        />
      );
    }
    return this.props.children;
  }
}

/**
 * 
 * @param {{
 *  children: React.JSX.Element | undefined;
 *  message: string;
 * }} params 
 */
export default function ErrorBoundary({
  children,
  message,
}) {
  return (
    <ErrorHandler
      children={children}
      message={message}
    />
  );
}
